import { Dispatch } from 'redux';
import { DictionariesEndpoint, Dictionary, Keys } from '@common/types';
import { DictionaryDeleteRequest, DictionaryOperation } from '@common/types/general/api/dictionary';
import { dictionaryPlannerRoutine } from '@modules/planning/children/by-date/actions';

export const handleDeleteRows =
  ({ dispatch, dictionary }: { dispatch: Dispatch; dictionary: Dictionary }) =>
  (ids: Keys | null): void => {
    if (!ids) return;
    const payload: DictionaryOperation<DictionaryDeleteRequest> & {
      dictionaryFetching?: boolean;
    } = {
      dictionary,
      ids,
      operation: DictionariesEndpoint.Delete
    };
    dispatch(dictionaryPlannerRoutine(payload));
  };
